import { useTranslation } from 'react-i18next';
import Styles from './styles.module.scss';

import logo from '../../../theme/assets/svg/tc_logo.svg';
import { buildCrossDomainLink } from '../../../utils/buildCrossDomainLink';

const Logo = ({ isLink = true, path = '/' }) => {

    const { i18n } = useTranslation();

    const lang = i18n.language?.startsWith('ru') ? 'ru' : 'en';
    const baseUrl = process.env.REACT_APP_NEXT_URL;

    const href = baseUrl
        ? buildCrossDomainLink({
            baseUrl,
            path,
            lang,
        })
        : path;

    if (isLink) {
        return (
            <a href={href} className={Styles.logoWrap}>
                <img src={logo} alt="Time Capsule" />
            </a>
        );
    }

    return (
        <div className={Styles.logoWrap}>
            <img src={logo} alt="Time Capsule" />
        </div>
    );
};

export default Logo;
